import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { ISharedWithMeContentInfo } from '../../ts/models/ISharedWithMeContentInfo';
import { GetSharedWithMeRequest } from '../../ts/ServerApi/requests/GetSharedWithMeRequest';

class SharedWithMeService {

  private getSharedWithMeContentInfo = new WebClientListResourceFetcher(GetSharedWithMeRequest, ServerApiMapper.sharedWithMe);

  public getSharedWithMe(): ResourceQuery<ISharedWithMeContentInfo> {
    return new ResourceQuery(this.getSharedWithMeContentInfo);
  }
}

export const SharedWithMe = new SharedWithMeService();
